import { Component, effect, inject, signal } from '@angular/core';
import { ModalComponent } from '../../../../shared/ui/modal/modal.component';
import { QrCodeComponent } from '../qr-code/qr-code.component';
import { ModalService } from '../../../../shared/utils/services/modal.service';
import { OrgService } from '../../../../shared/services/org.service';
import { TranslocoModule } from '@jsverse/transloco';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'qwiko-payment-qrcode',
  imports: [ModalComponent, QrCodeComponent, TranslocoModule],
  templateUrl: './payment-qrcode.component.html',
  styleUrl: './payment-qrcode.component.scss',
})
export class PaymentQRCodeComponent {
  modalService = inject(ModalService);
  orgService = inject(OrgService);

  paymentLinkEffect = effect(() => {
    if (this.orgService.org()?.code) {
      let link: string = '';
      link = `${environment.qrUrl}/?b=${this.orgService.org()?.code}`;
      this.link.set(link);

      // if (this.paymentCode()) {
      //   return `${environment.qrUrl}/?t=${this.paymentCode()}`;
      // }
      // if (this.selectedPaymentAccount()) {
      //   let link: string = '';
      //   if (this.isOffLineMode()) {
      //     return this.offlinePaymentLink();
      //   }

      //   link = `${environment.qrUrl}/?a=${this.selectedPaymentAccount()?.code}`;
      //   if (this.ussdAmount()) {
      //     link = `${environment.qrUrl}/?a=${this.selectedPaymentAccount()?.code}&am=${this.ussdAmount()}`;
      //   }
      //   return link;
      // } else if (this.orgService.org()?.code) {
      //   let link: string = '';
      //   if (this.isOffLineMode()) {
      //     return this.offlinePaymentLink();
      //   }
      //   link = `${environment.qrUrl}/?b=${this.orgService.org()?.code}`;
      //   if (this.ussdAmount()) {
      //     link = `${environment.qrUrl}/?b=${this.orgService.org()?.code}&am=${this.ussdAmount()}`;
      //   }
      //   return link;
      // } else {
      //   return null;
      // }
    }
  });
  link = signal<string>('');
}
